import { jsxs as b, jsx as p } from "react/jsx-runtime";
import { ThemeProvider as C } from "@mui/material/styles";
import v from "./theme.js";
import * as x from "react";
import { u as k, P as u } from "../DefaultPropsProvider-OJ3TZ31B.mjs";
import { g as y } from "../index-Ch1ozFux.mjs";
import '../assets/OtcThemeProvider.css';const d = typeof y({}) == "function", O = (o, e) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...e && !o.vars && {
    colorScheme: o.palette.mode
  }
}), E = (o) => ({
  color: (o.vars || o).palette.text.primary,
  ...o.typography.body1,
  backgroundColor: (o.vars || o).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (o.vars || o).palette.common.white
  }
}), g = (o, e = !1) => {
  var s, c;
  const r = {};
  e && o.colorSchemes && typeof o.getColorSchemeSelector == "function" && Object.entries(o.colorSchemes).forEach(([a, f]) => {
    var m, S;
    const i = o.getColorSchemeSelector(a);
    i.startsWith("@") ? r[i] = {
      ":root": {
        colorScheme: (m = f.palette) == null ? void 0 : m.mode
      }
    } : r[i.replace(/\s*&/, "")] = {
      colorScheme: (S = f.palette) == null ? void 0 : S.mode
    };
  });
  let t = {
    html: O(o, e),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: o.typography.fontWeightBold
    },
    body: {
      margin: 0,
      // Remove the margin in all browsers.
      ...E(o),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (o.vars || o).palette.background.default
      }
    },
    ...r
  };
  const l = (c = (s = o.components) == null ? void 0 : s.MuiCssBaseline) == null ? void 0 : c.styleOverrides;
  return l && (t = [t, l]), t;
}, n = "mui-ecs", T = (o) => {
  const e = g(o, !1), r = Array.isArray(e) ? e[0] : e;
  return !o.vars && r && (r.html[`:root:has(${n})`] = {
    colorScheme: o.palette.mode
  }), o.colorSchemes && Object.entries(o.colorSchemes).forEach(([t, l]) => {
    var c, a;
    const s = o.getColorSchemeSelector(t);
    s.startsWith("@") ? r[s] = {
      [`:root:not(:has(.${n}))`]: {
        colorScheme: (c = l.palette) == null ? void 0 : c.mode
      }
    } : r[s.replace(/\s*&/, "")] = {
      [`&:not(:has(.${n}))`]: {
        colorScheme: (a = l.palette) == null ? void 0 : a.mode
      }
    };
  }), e;
}, W = y(d ? ({
  theme: o,
  enableColorScheme: e
}) => g(o, e) : ({
  theme: o
}) => T(o));
function h(o) {
  const e = k({
    props: o,
    name: "MuiCssBaseline"
  }), {
    children: r,
    enableColorScheme: t = !1
  } = e;
  return /* @__PURE__ */ b(x.Fragment, {
    children: [d && /* @__PURE__ */ p(W, {
      enableColorScheme: t
    }), !d && !t && /* @__PURE__ */ p("span", {
      className: n,
      style: {
        display: "none"
      }
    }), r]
  });
}
process.env.NODE_ENV !== "production" && (h.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: u.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: u.bool
});
const D = ({ children: o }) => /* @__PURE__ */ b(C, { theme: v, children: [
  /* @__PURE__ */ p(h, {}),
  o
] });
export {
  D as default
};
